import namedMediaQuery from 'fela-plugin-named-media-query';

export const namedMediaQueryPlugin = namedMediaQuery({
  middle: '@media (max-width: 1350px)',
  mobile: '@media (max-width: 1024px)',
  small: '@media (max-width: 600px)',
  tiny: '@media (max-width: 374px)',
});



// WEBPACK FOOTER //
// ./src/util/namedMediaQueries.js